<i18n src="@/locales/models/harvested_batch.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/harvested_package.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/harvested_exp_package.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/views/organization/process/harvest_export/new_exported_batch.yml"
  lang="yaml"
></i18n>
<template>
  <div class="pt-4 space-y-4" v-for="(harvested_batch, index) in harvested_batches" :key="index">
    <div class="flex justify-end">
      <span @click.prevent="removeHarvestedBatch(index)">
        <i class="fa-solid fa-xmark fa-xl text-gray-400 cursor-pointer"></i>
      </span>
    </div>
    <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
      <div class="sm:col-span-2">
        <label class="label-form">
          {{ $t("model.harvested_batch.batch_code") }}
        </label>
        <div class="mt-1">
          <input type="text" v-model.trim="harvested_batch.batch_code" :class="['input-text', isInvalid('batch_code')]" />
        </div>
      </div>
      <div class="sm:col-span-2">
        <label class="label-form">
          {{ $t("model.harvested_batch.producer") }}
        </label>
        <div class="mt-1">
          <select-form v-if="producers.length > 0" :options="producers" label="full_label"
            v-model="harvested_batch.producer_id" :is_invalid="isInvalidSelect('producer')" />
        </div>
      </div>

      <div class="sm:col-span-2">
        <label class="label-form">
          {{ $t("model.harvested_batch.crop_field") }}
        </label>
        <div class="mt-1" v-if="cropFieldByProducer(harvested_batch.producer_id).length > 1">
          <select-form :options="cropFieldByProducer(harvested_batch.producer_id)" v-model="harvested_batch.crop_field_id"
            :is_invalid="isInvalidSelect('crop_field')" />
        </div>
        <dd class="content-data" v-else-if="cropFieldByProducer(harvested_batch.producer_id).length == 1
          ">
          {{ cropFieldByProducer(harvested_batch.producer_id)[0].name }}
        </dd>
      </div>
      <div class="sm:col-span-1" v-if="crop_types.length > 1">
        <label class="label-form">
          {{ $t("model.harvested_batch.crop_type") }}
        </label>
        <div class="mt-1" v-if="crop_types.length > 1">
          <select-form :options="crop_types" v-model="harvested_batch.crop_type_id"
            :is_invalid="isInvalidSelect('crop_type')" />
        </div>
        <dd class="content-data" v-else-if="crop_types.length == 1">
          {{ crop_types[0].name }}
        </dd>
      </div>
      <div class="sm:col-span-2">
        <label class="label-form">
          {{ $t("model.harvested_batch.harvest_team") }}
        </label>
        <div class="mt-1" v-if="harvest_teams.length > 1">
          <select-form :options="harvest_teams" v-model="harvested_batch.harvest_team_id"
            :is_invalid="isInvalidSelect('harvest_team')" />
        </div>
        <dd class="content-data" v-else-if="harvest_teams.length == 1">
          {{ harvest_teams[0].name }}
        </dd>
      </div>
      <template v-for="(crop_har_package, index) in crop_har_packages" :key="crop_har_package.id">
        <div class="sm:col-span-2">
          <label class="label-form">
            {{ $t("model.harvested_package.number") }} ({{
              crop_har_package.name
            }})
          </label>
          <div class="flex mt-1">
            <input type="text" v-model.number.trim="harvested_batch.harvested_packages[index].number
                " :class="['input-text', isInvalid('number')]" />
          </div>
        </div>
      </template>
    </div>
    <div>
      <div v-for="(
          harvested_exp_package, index
        ) in harvested_batch.harvested_exp_packages" :key="index" class="py-4">
        <div class="flex justify-end" v-if="display_add_remove_buttons">
          <span @click.prevent="removeHarvestedExpPackage(harvested_batch, index)">
            <i class="fa-solid fa-xmark fa-xl text-gray-400 cursor-pointer"></i>
          </span>
        </div>
        <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-3">
          <div class="sm:col-span-1">
            <label class="label-form">
              {{ $t("model.harvested_exp_package.crop_exp_package") }}
            </label>
            <div class="mt-1" v-if="crop_exp_packages.length > 1">
              <select-form :options="crop_exp_packages" v-model="harvested_exp_package.crop_package_id" />
            </div>
            <dd class="content-data" v-else-if="crop_exp_packages.length == 1">
              {{ crop_exp_packages[0].name }}
            </dd>
          </div>
          <div class="sm:col-span-1" v-if="crop_categories.length > 1">
            <label class="label-form">
              {{ $t("model.harvested_exp_package.crop_category") }}
            </label>
            <div class="mt-1" v-if="crop_categories.length > 1">
              <select-form :options="crop_categories" v-model="harvested_exp_package.crop_category_id" />
            </div>
            <dd class="content-data" v-else-if="crop_categories.length == 1">
              {{ crop_categories[0].name }}
            </dd>
          </div>
          <div class="sm:col-span-1" v-if="crop_sizes.length > 1">
            <label class="label-form">
              {{ $t("model.harvested_exp_package.crop_size") }}
            </label>
            <div class="mt-1" v-if="crop_sizes.length > 1">
              <select-form :options="crop_sizes" v-model="harvested_exp_package.exporter_process_crop_size_id" />
            </div>
            <dd class="content-data" v-else-if="crop_sizes.length == 1">
              {{ crop_sizes[0].name }}
            </dd>
          </div>
          <div class="sm:col-span-1">
            <label class="label-form">
              {{ $t("model.harvested_exp_package.number") }}
            </label>
            <div class="mt-1">
              <input type="text" v-model.trim="harvested_exp_package.number"
                :class="['input-text', isInvalid('number')]" />
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-end mt-4" v-if="display_add_remove_buttons">
        <white-button @click.prevent="addHarvestedExpPackage(harvested_batch)"
          :label="$t('labels.add_harvested_exp_package_button')" />
      </div>
    </div>
  </div>
  <div class="flex justify-end pt-4 space-x-4">
    <div class="mt-1">
      <switch-form v-model="same_producer" :label="$t('labels.same_producer')" />
    </div>
    <white-button @click.prevent="addHarvestedBatch()" :label="$t('labels.add_harvested_batch_button')" />
  </div>
</template>

<script>
import Requester from "@/views/organization/requesters/process/harvest_export/manage_harvested_batch.js";

export default {
  name: "OrgProcessHarvestExportHarvestedBatches",
  data() {
    return {
      harvested_batches: this.modelValue,
      same_producer: false,
      harvested_batch_default: {
        batch_code: "",
        total_weight: null,
        crop_type_id: null,
        producer_id: null,
        harvest_team_id: null,
        crop_field_id: null,
        harvested_exp_packages: [],
        harvested_packages: []
      },
      harvested_exp_package_default: {
        crop_exp_package_id: null,
        crop_category_id: null,
        crop_size_id: null,
        number: null
      },
      crop_har_packages: [],
      crop_types: [],
      harvest_teams: [],
      producers: [],
      crop_fields: {},
      crop_varieties: [],
      crop_exp_packages: []
    };
  },
  props: {
    modelValue: { type: Object, required: true },
    organization_id: { required: true },
    harvest_process_id: { required: true },
    exported_batch: { required: true },
    pr_crop_categories: { required: true },
    pr_crop_exp_packages: { required: true },
    pr_crop_sizes: { required: true }
  },
  created() {
    this.loadData();
  },
  computed: {
    display_add_remove_buttons: function () {
      return (
        this.crop_exp_packages.length > 1 &&
        this.crop_categories.length > 1 &&
        this.crop_sizes.length > 1
      );
    },
    crop_categories: function () {
      return this.pr_crop_categories.map(crop_category => {
        return {
          id: crop_category.crop_category_id,
          name: crop_category.name,
          ex_process_crop_category_id: crop_category.id
        };
      });
    },
    crop_sizes: function () {
      return this.pr_crop_sizes.map(crop_size => {
        return {
          id: crop_size.crop_size_id,
          name: crop_size.name,
          ex_process_crop_size_id: crop_size.id
        };
      });
    }
  },
  methods: {
    loadData: async function () {
      await this.fetchCropHarPackages();
      await this.fetchCropTypes();
      await this.fetchHarvestTeams();
      await this.fetchProducers();
      await this.fetchCropExpPackages();
      this.harvested_exp_package_default.crop_category_id = this.hasOneItem(
        this.crop_categories
      );
      this.harvested_exp_package_default.crop_size_id = this.hasOneItem(
        this.crop_sizes
      );
    },
    hasOneItem: function (array) {
      return array.length == 1 ? array[0].id : null;
    },
    cropFieldByProducer: function (producer_id) {
      return this.crop_fields[`${producer_id}`] || [];
    },
    fetchProducers: async function () {
      const response = await Requester.fetchProducers(this.organization_id);
      this.producers = response.data;
      this.producers.forEach(producer => {
        producer.full_label = `${producer.organization_producer_code} - ${producer.fullname}`;
      });
    },
    fetchCropFields: async function (harvested_batch) {
      const response = await Requester.fetchCropFields(
        this.organization_id,
        this.harvest_process_id,
        harvested_batch.producer_id
      );
      this.crop_fields[`${harvested_batch.producer_id}`] = response.data;
      if (
        harvested_batch &&
        this.crop_fields[`${harvested_batch.producer_id}`].length == 1
      ) {
        harvested_batch.crop_field_id = this.hasOneItem(
          this.crop_fields[`${harvested_batch.producer_id}`]
        );
      }
    },
    fetchCropExpPackages: async function () {
      const response = await Requester.fetchCropExpPackages(
        this.organization_id,
        this.harvest_process_id
      );
      this.crop_exp_packages = response.data;
      this.harvested_exp_package_default.crop_exp_package_id = this.hasOneItem(
        this.crop_exp_packages
      );
    },
    fetchCropHarPackages: async function () {
      const response = await Requester.fetchCropHarPackages(
        this.organization_id,
        this.harvest_process_id
      );
      this.crop_har_packages = response.data;
      this.harvested_batch_default.harvested_packages =
        this.crop_har_packages.map(item => {
          return {
            crop_har_package_id: item.id,
            number: null
          };
        });
    },
    fetchCropTypes: async function () {
      const response = await Requester.fetchCropTypes(
        this.organization_id,
        this.harvest_process_id
      );
      this.crop_types = response.data;
      this.harvested_batch_default.crop_type_id = this.hasOneItem(
        this.crop_types
      );
    },
    fetchHarvestTeams: async function () {
      const response = await Requester.fetchHarvestTeams(
        this.organization_id,
        this.harvest_process_id
      );
      this.harvest_teams = response.data;
      this.harvest_teams.forEach(team => {
        team["name"] = team.harvest_team_code;
      });
    },
    addHarvestedBatch: function () {
      let batch = { ...this.harvested_batch_default };
      batch.harvested_exp_packages = [
        { ...this.harvested_exp_package_default }
      ];
      if (this.same_producer) {
        batch.producer_id = this.exported_batch.producer_id;
        batch.batch_code = this.exported_batch.batch_code;
        this.fillExpPackageToSameProducer(batch);
      }
      batch["harvested_packages"] =
        this.harvested_batch_default.harvested_packages.map(har_pkg => {
          return { ...har_pkg };
        });
      this.harvested_batches.push({ ...batch });
    },
    removeHarvestedBatch: function (index) {
      this.harvested_batches.splice(index, 1);
    },
    fillExpPackageToSameProducer: function (batch) {
      if (this.exported_batch.packages.length == 1) {
        const pkg = this.exported_batch.packages[0];
        batch.harvested_exp_packages[0].crop_exp_package_id =
          this.pr_crop_exp_packages.find(
            exp_package =>
              exp_package.id == pkg.exporter_process_crop_package_id
          )?.crop_exp_package_id;

        batch.harvested_exp_packages[0].crop_category_id =
          this.crop_categories.find(
            category =>
              category.ex_process_crop_category_id ==
              pkg.exporter_process_crop_category_id
          ).id;

        batch.harvested_exp_packages[0].crop_size_id = this.crop_sizes.find(
          crop_size =>
            crop_size.ex_process_crop_size_id ==
            pkg.exporter_process_crop_size_id
        ).id;
        batch.harvested_exp_packages[0].number = pkg.quantity;
      }
    },
    addHarvestedExpPackage: function (harvested_batch) {
      harvested_batch.harvested_exp_packages.push({
        ...this.harvested_exp_package_default
      });
    },
    removeHarvestedExpPackage: function (harvested_batch, index) {
      harvested_batch.harvested_exp_packages.splice(index, 1);
      if (this.harvested_exp_packages.length == 0)
        this.addHarvestedExpPackage();
    }
  },
  watch: {
    harvested_batches: {
      handler: function (items) {
        items.forEach(item => {
          if (item.producer_id) this.fetchCropFields(item);
          else item.crop_field_id = null;
        });
      },
      deep: true
    }
  }
};
</script>
